import { createTheme, responsiveFontSizes } from "@material-ui/core"

let theme = createTheme({
    palette: {
      primary: {
        main: "#9A294B",
        contrastText: "white" 
      },
    }
});

theme = responsiveFontSizes(theme)
export default theme